import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf48029c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["href"]

import { CSSProperties } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: {},
    viewBox: { default: '0 0 1024 1024' },
    style: {}
  },
  setup(__props: any) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/19 12:11:57
 * @description: icon组件
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "icon",
    role: "img",
    style: _normalizeStyle(_ctx.style)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      width: "1em",
      height: "1em",
      "aria-hidden": "true",
      fill: "currentColor",
      viewBox: _ctx.viewBox
    }, [
      _createElementVNode("use", {
        href: `#icon-${_ctx.name}`
      }, null, 8, _hoisted_2)
    ], 8, _hoisted_1))
  ], 4))
}
}

})